import {createContext} from 'react';

export const MainMenuContext = createContext<{isMenuOpened: boolean, setIsMenuOpened: (newValue: boolean) => void}>({
  isMenuOpened: false,
  setIsMenuOpened: () => {
  },
});
